import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { ComponentRequisitionResponse } from '@/types/apps/component-requisition.type';
import type { ApiResponse, PaginatedResult } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface ComponentRequisitionGraphQLServiceInterface {}

type ComponentRequisitionListResponse = ApiResponse<
    PaginatedResult<ComponentRequisitionResponse>
>;

export class ComponentRequisitionGraphQLService
    extends BaseService
    implements ComponentRequisitionGraphQLServiceInterface
{
    public getEntityName(): string {
        return 'partRequisition';
    }

    public getFields(): Record<string, any> {
        return {
            code: true,
            contractCode: true,
            createdBy: true,
            createdDate: true,
            deletedAt: true,
            deletedBy: true,
            description: true,
            id: true,
            isDeleted: true,
            modifiedBy: true,
            modifiedDate: true,
            oppCode: true,
            partRequisitionStatus: true,
            requisitionDate: true,
            taskCheckId: true,
            taskCheck: {
                ticket: {
                    customer: {
                        id: true,
                        name: true,
                    },
                    customerId: true,
                },
                assigneeName: true,
                assigneeId: true,
                code: true,
            },
        };
    }

    public index(query: string): Promise<ComponentRequisitionListResponse> {
        return this.fetchGqlList(query, this.getEntityName());
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById() || !this.getRoleTypeManager().getQuery) {
            return {};
        }

        return this.getRoleTypeManager().getQuery('componentRecommendation', {
            userId: this.getQueryById(),
        });
    }
}
